import ServiceList from './ServiceList';

export { type ServiceListProps } from './ServiceList';
export default ServiceList;
